window.stateSchools = {};

var createCookie = function (name, value, days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));

        expires = "; expires=" + date.toGMTString();
    } else {
        expires = "";
    }
    document.cookie = name + "=" + value + expires + "; path=/";
};

var eraseCookie = function (name) {
    createCookie(name, "", - 1);
};

var resetHome = function () {
    eraseCookie('state');
    localStorage.setItem('state', 'other');
};

var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = decodeURIComponent(window.location.search.substring(1)),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');
        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : sParameterName[1];
        }
    }
};


// Init Foundation
jQuery(document).foundation();

// Close dropdowns on scroll
jQuery(window).scroll(function () {
    if (jQuery('#change-state').length) {
        jQuery('#change-state').foundation('close');
    }

    if (jQuery('login-dropdown').length) {
        jQuery('#login-dropdown').foundation('close');
    }
});

jQuery(document).ready(function ($) {

    function guestLogin(schoolID, firstName, lastName, emailAddress, userType) {

        //Submit to process_guest_login
        $.ajax({
            type: "POST",
            url: 'https://web.algebranation.com/api/process_guest_login',
            data: { schoolID: schoolID, firstName: firstName, lastName: lastName, emailAddress: emailAddress, userType: userType },
            xhrFields: {
                withCredentials: true
            },
            success: function (data) {
                if (data.errors.length === 0) {
                    window.location = "https://web.algebranation.com/";
                } else {
                    // Error in guest login?
                    $('#guest-login-modal').foundation('open');
                    $('#guest-login-modal .error').text(data.errors.login);
                    $('#guest-login-modal .school-id').val(schoolID);
                    $('#guest-login-modal .user-type').val(userType);
                }
            }
        });
    }

    var $modalSchool = jQuery("#select-school-modal"),
        $autocomplete = $modalSchool.find('input');

    var currentStateAbbreviation = $modalSchool.data('state');
    currentStateAbbreviation = currentStateAbbreviation === 'nyc' ? 'ny' : currentStateAbbreviation;

    if ($autocomplete.length) {
        $.ajax({
            url: 'https://web.algebranation.com/api/get_school_list_by_state',
            type: 'POST',
            dataType: 'json',
            data: { currentStateAbbreviation: currentStateAbbreviation },
            success: function (results, textStatus, xhr) {
                window.stateSchools = results.data.schools;
                $autocomplete.autocomplete("enable");
            }
        });

        $autocomplete.autocomplete({
            delay: 500,
            minLength: 3,
            disabled: true,
            appendTo: ".content-autocomplete",
            select: function (event, ui) {
                event.preventDefault();
                
                // Check Michigan portal redirect url
                if (ui.item.portal_redirect !== '') {
                    window.location.href = ui.item.portal_redirect;
                } else {
                    // Clever schools; they behave the same in all states
                    if (ui.item.is_clever === '1') {

                        if (!jQuery('.ui-menu').hasClass('no-results')) {
                            // window.location.href = "https://clever.com/oauth/instant-login?client_id=7271c1bc6f814e08724&district_id=" + ui.item.value;
                            window.location.assign("https://clever.com/oauth/instant-login?client_id=7271c1bc6f814e08724&district_id=" + ui.item.value);
                        }

                    } else {  // Non-Clever schools

                        if (currentStateAbbreviation === 'nyc') {  // NYC Login

                            // Next modal - user type select
                            $('#select-user-type-modal').foundation('open');
                            $('#select-school-modal').foundation('close');


                            // Student/teacher button clicked
                            $("#select-user-type-modal .button").on('click', function () {
                                var userType = $(this).data('usertype');
                                var parent = $("#school-user-pass-modal");
                                var schoolID = ui.item.id;
                                $('.button', parent).data('usertype', userType);
                                $('form', parent).attr('novalidate', '');

                                // TEACHERS
                                if (userType === "teacher") {
                                    if (ui.item.is_manual) {
                                        // Open guest login form
                                        $('#teacher-guest-login-modal').attr('data-school-id', schoolID);
                                        $('#teacher-guest-login-modal').foundation('open');
                                    } else {
                                        // Open full login form
                                        $('#school-user-pass-teacher-modal').foundation('open');
                                    }

                                    // STUDENTS
                                } else {
                                    if (ui.item.is_manual) {

                                        // Auto guest login
                                        const userType = 'CD73502828457D15655BBD7A63FB0BC8';
                                        // console.log({userType});
                                        // console.log({schoolID});
                                        // console.log('AJAXING to process_guest_login - STUDENT');
                                        guestLogin(schoolID, 'student_first', 'student_last', 'email@algebranation.com', userType);

                                    } else {
                                        $('#school-user-pass-modal').foundation('open');
                                    }
                                }

                                $('#select-user-type-modal').foundation('close');
                            });


                            // Teacher guest login form
                            $('.teacher-guest-login-form', '#teacher-guest-login-modal').on('submit', function (e) {
                                e.preventDefault();
                                const userType = "8D788385431273D11E8B43BB78F3AA41",
                                    firstName = $('#teacher-guest-first-name').val(),
                                    lastName = $('#teacher-guest-last-name').val(),
                                    emailAddress = $('#teacher-guest-email').val(),
                                    schoolID = ui.item.id;

                                console.log('AJAXING to process_guest_login - TEACHER');

                                guestLogin(schoolID, firstName, lastName, emailAddress, userType);

                            });

                            // Non-guest NYC login
                            $('#school-user-pass-form, #school-user-pass-teacher-modal').on('submit', function (e) {
                                e.preventDefault();

                                var state = currentStateAbbreviation;
                                var userType = $('#school-user-pass-modal').data('usertype');
                                var username = $('#school-username').val() || $('#school-username-1').val();
                                var password = $('#school-password').val() || '';
                                var birthday = $('#birthday').val(); // Logging in with birthday instead of password?

                                if (parseInt(birthday) === 1) {

                                    console.log('Birthday entered');
                                    var userType = $('#school-user-pass-modal .button').data('usertype');
                                    var year = $('#birthday-year').val();
                                    var month = $('#birthday-month').val();
                                    var day = $('#birthday-day').val();

                                    if (userType === "student") {
                                        if (year === '' || month === '' || day === '') {
                                            $('#school-user-pass-modal .error').text('Please enter your birthday to continue.');
                                        } else {
                                            password = year + '-' + month + '-' + day;
                                        }
                                    }
                                } else {
                                    birthday = 0;
                                }

                                if (password) {
                                    console.log('AJAXING to process_login');
                                    $.ajax({
                                        type: "POST",
                                        url: 'https://web.algebranation.com/api/process_login',
                                        data: { schoolID: ui.item.id, username: username, password: password, birthday: birthday, state: state, userType: userType },
                                        xhrFields: {
                                            withCredentials: true
                                        },
                                        success: function (data) {
                                            if (data.errors.length === 0) {
                                                window.location = "https://web.algebranation.com/";
                                            } else {
                                                if ($('#school-username-1').val()) {
                                                    $('#school-user-pass-teacher-modal').foundation('close');
                                                } else {
                                                    $('#school-user-pass-modal').foundation('close');
                                                }
                                                $('#guest-login-modal').foundation('open');
                                                $('#guest-login-modal').attr('data-user-type', userType);
                                                $('#guest-login-modal').attr('data-school-id', ui.item.id);
                                                $('#guest-login-modal .error').text(data.errors.login);
                                                $('#guest-login-modal .school-id').val(ui.item.id);
                                                $('#guest-login-modal .user-type').val(userType);
                                            }
                                        }
                                    });
                                }
                            });

                            //NYC guest modal acces as a guest 
                            $('#guest-login-modal').on('click', '.go-to-guest-login', function (e) {
                                e.preventDefault();
                                var userType = $('#guest-login-modal').data('user-type'),
                                    schoolID = $('#guest-login-modal').data('school-id');
                                if (userType === 'student') {
                                    // Auto guest login
                                    console.log('gonna auto log in with schoolID', schoolID);
                                    guestLogin(schoolID, 'student_first', 'student_last', 'email@algebranation.com', 'CD73502828457D15655BBD7A63FB0BC8');
                                } else {
                                    // Take to teacher guest login form
                                    $('#teacher-guest-login-modal').foundation('open');
                                }
                                $('#guest-login-modal').foundation('close');
                            });

                            // NYC guest modal go back
                            $('#guest-login-modal').on('click', '.go-back', function (e) {
                                e.preventDefault();
                                var userType = $('#guest-login-modal').data('user-type');
                                if (userType === 'student') {
                                    $('#school-user-pass-modal').foundation('open');
                                } else {
                                    $('#school-user-pass-teacher-modal').foundation('open');
                                }
                                $('#guest-login-modal').foundation('close');
                            });

                        } else {    // Non-NYC Login

                            if (ui.item.is_manual === '1') {   // Manual
                                // Open guest login modal
                                $('.school-id', '#select-manual-guest-modal').val(ui.item.id);
                                $('#select-manual-guest-modal').foundation('open');
                                $('#select-school-modal').foundation('close');
                            } else {  // Non-manual
                                // Make form and add school id as hidden value and post that
                                var form = $('<form action="https://web.algebranation.com/authentication/school_chosen" method="post">' +
                                    '<input type="hidden" value="' + ui.item.id + '" name="school-id" />' +
                                    '</form>');
                                $('body').append(form);
                                form.submit();
                            }
                        }
                    }
                }
            },
            focus: function (event, ui) {
                event.preventDefault();
                $autocomplete.val(ui.item.label);
            },
            response: function (event, ui) {
                if (!ui.content.length) {
                    var email = "help@mathnation.com";
                    jQuery('.no-results a').attr('href', 'mailto:' + email);
                    jQuery('.no-results a').text(email);
                    var state = $modalSchool.data('state');
                    // noResult = {
                    //   value: "",
                    //   //label: "No school found."
                    //   label: "No school found. E-mail " + email
                    // }
                    //ui.content.push(noResult);
                    jQuery('.no-results').show();
                } else {
                    jQuery('.no-results').hide();
                }
            },
            source: function (request, response) {
                var matcher = new RegExp($.ui.autocomplete.escapeRegex(request.term), "i");
                response($.map($.grep(window.stateSchools, function (item) {
                    return matcher.test(item['display_name']);
                }), function (n) {
                    return {
                        "id": n['id'],
                        "is_clever": n['is_clever_oauth_required'],
                        "is_manual": n['is_manually_added'],
                        "portal_redirect": n['redirect_to_portal_url'],
                        "label": n['display_name'],
                        "value": n['district_clever_id'],
                        "city": n['city'],
                    };
                }));
            }
        }).data("ui-autocomplete")._renderItem = function (ul, item) {
            return $("<li />")
                .data("ui-autocomplete-item", item)
                .append(item.label + ' - ' + (item.city ? item.city : currentStateAbbreviation))
                .appendTo(ul);
        };
    }

});

function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i <ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }


jQuery(document).ready(function ($) {
    if ($('.page-template-page-front').length > 0) {
        localStorage.removeItem('state');
    }

    // Add login button handler
    $('.login.menu-button').on('click', 'a', function (e) {
        e.preventDefault();
        $('#select-school-modal').foundation('open');
    });
    // Front page masthead login button handler
    $('.login').on('click', '.button', function (e) {
        e.preventDefault();
        $('#select-school-modal').foundation('open');
    });
    $('.js-open-blank-page').on('click', 'a', function () {
        //e.preventDefault();
        eraseCookie('state');
        localStorage.setItem('state', 'other');
        //window.location.href = document.location.origin;
    });

    // Change state -- reset home
    $('.current-state').on('click', '.change-state-link', resetHome());

    // Alternate open event for login modal
    $('.manual-open-login').on('click', function (e) {
        e.preventDefault();
        $('#select-school-modal').foundation('open');
    });

    $('#select-school-modal').on('click', function (e) {
        if ($(e.target) !== $(this)) {
            $('.no-results').hide();
        }
    });

    // Mobile app download prompt for NYC
    $('.mobile-app-download.menu-button').on('click', 'a', function (e) {
        e.preventDefault();
        $('#mobile-app-download').foundation('open');
    });




    // // // // //



    // Trigger SC info modal
    $('.sc-more-info').on('click', 'a', function (e) {
        e.preventDefault();
        $('#sc-more-info-modal').foundation('open');
    });


    // Trigger school select modal
    var argument = '';
    if (window.location.toString().split('?')[1]) {
        argument = window.location.toString().split('?')[1].split('=')[1];
    }
    if (window.location.hash === '#school' || argument === 'school') {
        $('#select-school-modal').foundation('open');
    }

    // Trigger school select with hash
    if (window.location.hash === '#school') {
        $('#select-school-modal').foundation('open');
    }


    // Trigger "Learn More" state select modal only on algebranation.com/learnmore
    var domain = window.location.hostname;
    var path = window.location.pathname.replace(/\//g, '');
    var domainParts = domain.split('.');
    if (path === 'learnmore' && domainParts.indexOf('mathnation') === -1) {
        $('#learn-more-state-select-modal').foundation('open');
    }

    // Trigger FAQ state select modal
    if ($('.faq-selector-page').length) {
        $('#faq-state-select-modal').foundation('open');
    }

    // Process FAQ state select modal
    $('#faq-state-select-modal').on('click', '.state-selection', function (e) {
        e.preventDefault();
        var state = e.target.dataset.state;
        var stateName = e.target.innerText;

        // Move content
        $('.state-select').css('transform', 'translateX(-800px)');
        $('.faq-type-select').css('transform', 'translateX(0)');

        // Set title
        $('.faq-type-select h2').text(stateName + ' FAQs');

        // Build links
        var links = $('.faq-type-select').find('a');
        links.each(function () {
            var href = $(this).data('url');
            $(this).attr('href', '/' + state + href);
        });
    });
    // Go back
    $('#faq-state-select-modal').on('click', '.back', function (e) {
        e.preventDefault();
        $('.state-select').css('transform', 'translateX(0)');
        $('.faq-type-select').css('transform', 'translateX(800px)');
    });

    // Activate menu items on GET params
    var ref = getUrlParameter('ref');
    $('.main-nav a').each(function () {
        if ($(this).text().toLowerCase() === ref) {
            $(this).parent().addClass('current-menu-item');
        }
    });
    // Activate submenu link for Components page
    $('.submenu a').each(function () {
        if ($(this).text().toLowerCase() === $('.page-content h1').text().toLowerCase()) {
            $(this).parent().addClass('current-menu-item');
        }
    });
    // Move social share buttons
    var socialButtons = $('#socialButtonOnPage').detach();
    $('.social-share').append(socialButtons);


    // Substitute Algebra Nation for Math Nation on redirects
    // Will do this for every URL with a ?ref=mathnation parameter


    // if (window.location.search.includes('ref=mathnation')) {
    //     var target = document.querySelector('.page-content');
    //     target.innerHTML = target.innerHTML.replace(/Algebra Nation/g,'Math Nation');
    //     target.innerHTML = target.innerHTML.replace(/Algebra Wall/g,'Math Wall');
    //     target.innerHTML = target.innerHTML.replace(/AlgebraNation/g,'MathNation');
    //     target.innerHTML = target.innerHTML.replace(/algebranation/g,'algebranation');
    // }



    // Workbook ordering page

    $('#accept-disclaimer').on('change', function () {
        $('.paypal-button').toggleClass('accepted', this.checked);
    });

/*
    $( "ul.state-list li a:contains('New York')" ).click(function( event ) {
        event.preventDefault();
        $( "#state-select-modal" ).foundation('close');
        $( "#select-school-modal" ).foundation('open');
    });
*/
    
    $( ".no-state-selected" ).click(function( event ) {
        event.preventDefault();
        $( "#state-select-modal" ).foundation('open');
    });

    
    $( ".small-header.hide-for-large .menu-icon" ).click(function( event ) {
        $( "#off-canvas" ).foundation('open');
    });

    //stores selected state in cookie
    $(".state-list li a").click(function( event ) {
        document.cookie = "state_selected=" + $(this).text();
    });

    if($(".state-name").text().trim().length == 0){
        if(getCookie("state_selected") == ""){
            $(".state-name").text("Other");
        }
        else {
            $(".state-name").text(getCookie("state_selected"));
        }
    }

    if($("#deeplinked-accordion").length > 0){

        var hash = $(location).attr('hash');

        if(hash.length > 0 && $(hash).length > 0){

            jQuery('#deeplinked-accordion').foundation('toggle', $(hash));
            
            $('html, body').animate({
                scrollTop: $(hash).offset().top - 100
            }, 500);
        }
    }

    


});